// @ts-nocheck
import type * as Types from '../../../types/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetOrderFeesQueryVariables = Types.Exact<{
  input: Types.OrderCalculationInput;
}>;


export type GetOrderFeesQuery = { __typename?: 'Query', orderCalculation: { __typename?: 'OrderCalculation', withCoveringFees: { __typename?: 'OrderCalculationResult', net: number, gross: number, fee: number }, withoutCoveringFees: { __typename?: 'OrderCalculationResult', net: number, gross: number, fee: number } } };


export const GetOrderFeesDocument = /*#__PURE__*/ gql`
    query GetOrderFees($input: OrderCalculationInput!) {
  orderCalculation(input: $input) {
    withCoveringFees {
      net
      gross
      fee
    }
    withoutCoveringFees {
      net
      gross
      fee
    }
  }
}
    `;

/**
 * __useGetOrderFeesQuery__
 *
 * To run a query within a React component, call `useGetOrderFeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderFeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderFeesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetOrderFeesQuery(baseOptions: Apollo.QueryHookOptions<GetOrderFeesQuery, GetOrderFeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderFeesQuery, GetOrderFeesQueryVariables>(GetOrderFeesDocument, options);
      }
export function useGetOrderFeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderFeesQuery, GetOrderFeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderFeesQuery, GetOrderFeesQueryVariables>(GetOrderFeesDocument, options);
        }
export function useGetOrderFeesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrderFeesQuery, GetOrderFeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrderFeesQuery, GetOrderFeesQueryVariables>(GetOrderFeesDocument, options);
        }
export type GetOrderFeesQueryHookResult = ReturnType<typeof useGetOrderFeesQuery>;
export type GetOrderFeesLazyQueryHookResult = ReturnType<typeof useGetOrderFeesLazyQuery>;
export type GetOrderFeesSuspenseQueryHookResult = ReturnType<typeof useGetOrderFeesSuspenseQuery>;
export function refetchGetOrderFeesQuery(variables: GetOrderFeesQueryVariables) {
      return { query: GetOrderFeesDocument, variables: variables }
    }